import { colors, tokens } from "../theme.ts";
import { useCloseOnBack } from "../useCloseOnBack.ts";

/** An opaque sheet that slides up from the bottom. Mounted only while open; the Android back gesture closes it. */
export function BottomSheet({ onClose, children }: { onClose: () => void; children: React.ReactNode }) {
  useCloseOnBack(onClose);
  return (
    <div
      onClick={onClose}
      // The scrim is the ink token at 35%, the only dimming the sheet needs.
      style={{ position: "fixed", inset: 0, background: "rgba(43,39,36,0.35)", display: "flex", alignItems: "flex-end", zIndex: 40 }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: colors.sheet, width: "100%", maxWidth: 560, margin: "0 auto", boxSizing: "border-box",
          borderRadius: `${tokens.radius.sheet}px ${tokens.radius.sheet}px 0 0`,
          border: `1px solid ${colors.hair}`, borderBottom: "none",
          padding: `${tokens.space.cardPad + 4}px ${tokens.space.gutter + 4}px`,
          maxHeight: "min(80dvh, calc(100dvh - 48px - env(safe-area-inset-top)))",
          overflowY: "auto", overscrollBehavior: "contain",
        }}
      >
        {children}
        <div aria-hidden style={{ height: "env(safe-area-inset-bottom)" }} />
      </div>
    </div>
  );
}
